import { Button  } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import React from 'react';
import {

	MdOutlineFavorite,
	MdOutlineFavoriteBorder,
} from 'react-icons/md';

type InterestedButtonProps = ButtonProps & {
	isSelected:      boolean
	selectedLabel:   string
	unselectedLabel: string

	onSelect:   () => void
	onUnselect: () => void
};

export const InterestedButton = ({
	isSelected, onSelect, onUnselect, selectedLabel, unselectedLabel, ...rest
}: InterestedButtonProps) => {
	return (
		<Button
			variant="outline"
			{...rest}
			onClick={isSelected ? onUnselect : onSelect}
		>
			{isSelected ? <MdOutlineFavorite /> : <MdOutlineFavoriteBorder />}
			{isSelected ? selectedLabel : unselectedLabel}
		</Button>
	);
};
